import type { Config } from '@/config/types';

import { isDoNotTrackEnabled } from './doNotTrack';

interface GTagWindow extends Window {
  dataLayer: any[];
  gtag: (...args: any[]) => void;
}

declare const window: GTagWindow;

const loadGoogleAnalytics = (version: string, config: Config['googleTagManager']): void => {
  if (isDoNotTrackEnabled) {
    // eslint-disable-next-line no-console
    console.debug('Do Not Track enabled. Analytics was disabled.');
    return;
  }

  if (config.disabled) {
    // eslint-disable-next-line no-console
    console.info('Google Analytics tracking is disabled.');
    return;
  }

  const gaIdFromEnv = config.analystLayer;
  if (!gaIdFromEnv) {
    // eslint-disable-next-line no-console
    console.warn('GoogleTagId is not set. Google Analytics will not be loaded.');
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', gaIdFromEnv, {
    send_page_view: true,
    custom_map: {
      dimension1: 'app_version',
    },
  });

  if (version) {
    window.gtag('event', 'app_initialized', {
      app_version: version,
      non_interaction: true,
    });
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaIdFromEnv}`;

  script.onload = () => {
    // eslint-disable-next-line no-console
    console.info('Google Analytics loaded successfully');
  };

  script.onerror = (error) => {
    // eslint-disable-next-line no-console
    console.error('Failed to load Google Analytics', error);
  };

  document.head.appendChild(script);
};

export default loadGoogleAnalytics;
